import { CHAIN_ID } from 'config/constants/networks'
import addresses from 'config/constants/contracts'
import { Address } from 'config/constants/types'

export const getAddress = (address: Address, chainId: number): string => {
  if (!address) return ""
  return address[chainId] ? address[chainId] : address[CHAIN_ID.AVALANCHE]
}

export const getMulticallAddress = (chainId: number) => {
  return getAddress(addresses.multiCall, chainId)
}

export const getPurchaseCashierAddress = (chainId: number) => {
  return getAddress(addresses.purchaseCashierContr, chainId)
}

export const getRebaseAddress = (chainId: number) => {
  return getAddress(addresses.rebaseContr, chainId)
}